import {Observable} from 'rxjs';
import {ITicketAuthTransResp} from '../modelos/ITicketAuthTransResp';
import {CommonService} from './../../../shared/utils/common.service';
import {UtilsService} from './../../../shared/utils/utils.service';
import {Injectable} from '@angular/core';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';

@Injectable({
  providedIn: 'root',
})
export class TicketAutorizacionTransporteService {
  private diccionarioModulo: any;
  private url: string;
  private urlMaestros: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
    this.urlMaestros = this._util.getDatosMaestros();
  }

  obtener(): Observable<any[]> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.ticketAutorizacionTransporte.obtenerTodo
    );
  }

  obtenerPorId(idGarita: number): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url +
      this.diccionarioModulo.url.ticketAutorizacionTransporte.obtenerPorId +
      idGarita
    );
  }

  crear(request: any) {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.ticketAutorizacionTransporte.crear,
      request
    );
  }

  editar(request: any) {
    return this._commom.peticionPutConHeader(
      this.url + this.diccionarioModulo.url.ticketAutorizacionTransporte.actualizar,
      request
    );
  }

  borrar(params: number): Observable<any> {
    return this._commom.peticionPutConHeader(
      this.url +
      this.diccionarioModulo.url.ticketAutorizacionTransporte.eliminar +
      params, {}
    );
  }

  imprimir(request: ITicketAuthTransResp): Observable<any> {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.ticketAutorizacionTransporte.imprimir,
      request
    );
  }

  getCliente(cliente: string): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.urlMaestros +
      this.diccionarioModulo.url.ticketAutorizacionTransporte.getCliente +
      cliente
    );
  }

  validaDuplicidadTicket(idTicket: number): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.ticketAutorizacionTransporte.controlDuplicidad + idTicket
    );
  }

  getEstados(idEstado: number): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.ticketAutorizacionTransporte.getFiltros + idEstado);
  }

  //T.13581 GARITA EN TODAS LAS AGENCIAS 
  getReporteByFilter(idTicket, ticketId, garitaId, proveedorTranspId, tipo, estado, fInicio, fFin): Observable<any> {
    let QueryParam = 
    "?idTicket=" + idTicket +
    "&ticketId=" + ticketId +
    "&garitaId=" + garitaId +
    "&proveedorTranspId=" + proveedorTranspId +
    "&fechaInicio=" + fInicio +
    "&fechaFin=" + fFin +
    "&tipo=" + tipo ;
    
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.ticketAutorizacionTransporte.obtenerTodo + "/reporte" + QueryParam);
  }

}
